module.exports = __webpack_public_path__ + "static/media/shaff1154.0c6b3e2b.jpg";